import type { SkyscannerMichelinSearchV1Search } from '@skyscanner-internal/michelin-web-http-client';

type SearchRequestPageType = SkyscannerMichelinSearchV1Search.SearchRequestPageType;

export const POLLING_INTERVAL = 1000;
export const MAX_MICHELIN_QUERY_REQUESTS = 4;

export const PAGE_TYPE_UNSPECIFIED: SearchRequestPageType = 'PAGE_TYPE_UNSPECIFIED';
export const PAGE_TYPE_BOOKING_PANEL_INDICATIVE_PRICES: SearchRequestPageType =
  'PAGE_TYPE_BOOKING_PANEL_INDICATIVE_PRICES';
export const PAGE_TYPE_BOOKING_PANEL_PQS: SearchRequestPageType = 'PAGE_TYPE_BOOKING_PANEL_PQS';
export const PAGE_TYPE_EXPLORE_CITY_DRAWER: SearchRequestPageType = 'PAGE_TYPE_EXPLORE_CITY_DRAWER';
